/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faFileContract } from '@fortawesome/free-solid-svg-icons';

import TextDivider from '../../Parts/TextDivider';
import { useIsPsAdmin } from '../../hooks';

import PaymentMethodButton from './PaymentMethodButton';
import PaymentStep from './PaymentStep';
import apiCalls from '../../PowerShadesAPIFunctions';

const SelectPaymentMethod = ({
	quoteColor,
	quote,
	paymentMethodSelected,
	setAdminPayment,
	hideNext,
	showNext,
	hasCard,
	hasTerms,
	quoteType
}) => {
	const isPsAdmin = useIsPsAdmin();

	const quoteId = quote.id;

	const paymentMethods = {
		dealerTerms: (
			<PaymentMethodButton
				quoteColor={quoteColor}
				key="ct"
				icon={faFileContract}
				text="Dealer Terms"
				style={{ marginRight: '0.5em' }}
				onClick={() => {
					apiCalls.dealerTermsPressed(quoteId).then(() => {
						console.log('dealerTermsPressed');
					});

					paymentMethodSelected('dealer_terms');
				}}
			/>
		),

		card: (
			<PaymentMethodButton
				quoteColor={quoteColor}
				key="card"
				icon={faCreditCard}
				text="Card/ACH"
				style={{ marginRight: '0.5em' }}
				onClick={() => {
					apiCalls.ccAchPressed(quoteId).then(() => {
						console.log('ccAchPressed');
					});
					paymentMethodSelected('card');
				}}
			/>
		),

		psAdmin: (
			<PaymentMethodButton
				quoteColor={quoteColor}
				key="psaAdmin"
				icon={faCheck}
				text="PowerShades Admin"
				onClick={() => {
					apiCalls.psAdminPressed(quoteId).then(() => {
						console.log('psAdminPressed');
					});
					setAdminPayment(true);
				}}
			/>
		),

		rmaOverride: (
			<div title='Coming Soon'>
				<PaymentMethodButton
					quoteColor={quoteColor}
					key="rma"
					icon={faCheck}
					text="RMA Override"
					onClick={() => {
						paymentMethodSelected('rma_override');
					}}
				/>
			</div>
		)
	};

	const paymentOptions: Array<React.ReactElement> = [];

	if (!isPsAdmin) {
		parseInt(quote.require_payment, 10)
			|| (hasTerms && paymentOptions.push(paymentMethods.dealerTerms));
		hasCard && paymentOptions.push(paymentMethods.card);
	} else {
		paymentOptions.push(paymentMethods.psAdmin);
	}

	if (isPsAdmin && quoteType === "rma") {
		paymentOptions.push(paymentMethods.rmaOverride);
	}
	useEffect(() => {
		hideNext();
	}, []);

	return (
		<PaymentStep>
			<TextDivider>
				<h3 className={`text-${quoteType}`} style={{ fontWeight: 'normal' }}>
					Pay With
				</h3>
			</TextDivider>

			<div style={{ display: 'flex', flexDirection: 'row' }}>
				{paymentOptions.length > 0 ? (
					paymentOptions
				) : (
					<div>
						<h3
							className={`text-${quoteType}`}
							style={{ marginBottom: '5px', fontWeight: 'normal' }}
						>
							No Payment Methods Available
						</h3>
						<span style={{ fontWeight: 'normal' }}>
							Please contact your representative or PowerShades directly.
						</span>
					</div>
				)}
			</div>

			{parseInt(quote.require_payment, 10) ? (
				<span style={{ fontWeight: 'normal' }}>
					<br />
					<b>Dealer Credit Terms have been declined for this order.</b>
				</span>
			) : null}
		</PaymentStep>
	);
};

export default SelectPaymentMethod;
